import { FC, useState, useEffect, useCallback } from 'react';
import { SignatureRequestDialogProps } from './SignatureRequestDialog.types';
import styles from './SignatureRequestDialog.module.css';
import { Loading, Flex } from '@/_components';

export const SignatureRequestDialog: FC<SignatureRequestDialogProps> = ({
  signatureRequestId,
  companyId,
  onClose,
}) => {
  const [loaded, setLoaded] = useState(false);

  const [iframeRef, setIframeRef] = useState<HTMLIFrameElement | null>(null);

  const onElementAvailable = useCallback(
    (selector: any, callback: any) => {
      if (!iframeRef) {
        return;
      }

      const iframeDoc =
        iframeRef.contentDocument || iframeRef.contentWindow?.document;

      if (!iframeDoc) {
        return;
      }

      const observer = new MutationObserver((mutationsList, observer) => {
        for (const mutation of mutationsList) {
          if (mutation.type === 'childList') {
            const element = iframeDoc.querySelector(selector);
            if (element) {
              callback(element);
              observer.disconnect();
              return;
            }
          }
        }
      });

      observer.observe(iframeDoc, { childList: true, subtree: true });

      // Check if the element is already present
      const initialCheck = iframeDoc.querySelector(selector);

      if (initialCheck) {
        callback(initialCheck);
        observer.disconnect();
      }
    },
    [iframeRef],
  );

  useEffect(() => {
    if (iframeRef) {
      iframeRef.addEventListener('load', function () {
        onElementAvailable('.content-container', () => {
          setLoaded(true);
        });
      });
    }
  }, [iframeRef, onElementAvailable]);

  useEffect(() => {
    const handler = () => {
      if (onClose) {
        onClose();
      }
    };

    globalThis.document.addEventListener('closeDialog', handler);

    return () => {
      globalThis.document.removeEventListener('closeDialog', handler);
    };
  }, [onClose]);

  return (
    <Flex className={styles.dialogContainer} isYCentered isXCentered>
      {!loaded && <Loading size={40} />}

      <iframe
        ref={setIframeRef}
        src={`/review-signature-request/${signatureRequestId}?companyId=${companyId}`}
        className={styles.iframe}
        style={{ display: loaded ? 'block' : 'none' }}
      />
    </Flex>
  );
};
